import Vue from 'vue'
import App from './App.vue'
import Flutterwave from 'flutterwave-vue-v3'
import '@/assets/css/main.scss'
import '@/mixins'
import router from './router'

Vue.config.productionTip = false
Vue.use(Flutterwave, { publicKey: process.env.VUE_APP_RAVE_KEY })

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
